import { useQuery } from '@tanstack/react-query';
import { Major } from '@common-types';
import { getMajorsByCipCodes } from '@api/majors';

const byInterestThenOverallFit = (a: Major, b: Major) =>
  (a.interestFit ?? Infinity) - (b.interestFit ?? Infinity) ||
  (a.overallFit ?? Infinity) - (b.overallFit ?? Infinity) ||
  a.cipTitle.localeCompare(b.cipTitle);

export const getInterestMatchedPrograms = (majors: Major[]): Major[] =>
  majors.filter((major) => major.isBestFitSoc && !!major.interestFit).sort(byInterestThenOverallFit);

export const useProgramFits = (cipCodes: string[], enabled: boolean) =>
  useQuery({
    queryKey: ['programFits', cipCodes],
    queryFn: () => getMajorsByCipCodes(cipCodes),
    select: (result) => getInterestMatchedPrograms(result?.majors ?? []),
    enabled: enabled && cipCodes.length > 0,
    refetchOnWindowFocus: false,
  });
